(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfl-justdropped"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initTflJustDropped = (root) => {
    if (!root || root.dataset.tflInitialized === 'true') return;

    root.dataset.tflInitialized = 'true';

    const track = root.querySelector('[data-tfl-track]');
    const slides = Array.from(
      root.querySelectorAll('[data-tfl-slide]')
    );
    const prev = root.querySelector('[data-tfl-prev]');
    const next = root.querySelector('[data-tfl-next]');
    const dots = Array.from(
      root.querySelectorAll('[data-tfl-dot]')
    );

    if (!track) return;

    // Match the title space across all launch cards at the current viewport.
    // Longer product names remain fully visible; prices and buttons line up.
    const titles = Array.from(
      root.querySelectorAll('.tfl-just-dropped__product-title')
    );
    let titleLayoutFrame = null;

    const alignCards = () => {
      root.style.removeProperty('--tfl-synced-title-height');
      const tallestTitle = titles.reduce(
        (height, title) => Math.max(height, title.getBoundingClientRect().height),
        0
      );
      if (tallestTitle) {
        root.style.setProperty('--tfl-synced-title-height', `${Math.ceil(tallestTitle)}px`);
      }
    };

    const queueAlignment = () => {
      if (titleLayoutFrame !== null) cancelAnimationFrame(titleLayoutFrame);
      titleLayoutFrame = requestAnimationFrame(() => {
        alignCards();
        titleLayoutFrame = null;
      });
    };

    queueAlignment();
    document.fonts?.ready.then(queueAlignment);
    window.addEventListener('resize', queueAlignment);

    if (slides.length < 2) return;

    const isMobile = () =>
      window.matchMedia('(max-width: 749px)').matches;

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;

        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const nearestIndex = () => {
      const trackLeft =
        track.getBoundingClientRect().left;

      let bestIndex = 0;
      let bestDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(
          slide.getBoundingClientRect().left -
          trackLeft
        );

        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    };

    const goTo = (index) => {
      if (!isMobile()) return;

      const clamped = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      slides[clamped].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });

      setActive(clamped);
    };

    prev?.addEventListener('click', () => {
      goTo(nearestIndex() - 1);
    });

    next?.addEventListener('click', () => {
      goTo(nearestIndex() + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goTo(index));
    });

    let frame = null;

    track.addEventListener('scroll', () => {
      if (!isMobile()) return;

      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        setActive(nearestIndex());
      });
    }, { passive: true });
  };

  document
    .querySelectorAll(
      '.tfl-just-dropped[data-section-id]'
    )
    .forEach(initTflJustDropped);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const root = event.target.querySelector?.(
        '.tfl-just-dropped[data-section-id]'
      );

      initTflJustDropped(root);
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfl-moment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tfl-moment')) {
  customElements.define('tfl-moment', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;

      /* Keep reviews beneath photography on desktop, but move the SAME
         Loox block to the end of the buying/story content on mobile. */
      const reviews = this.querySelector('.tfl-moment__reviews');
      const gallery = this.querySelector('.tfl-moment__gallery');
      const buy = this.querySelector('.tfl-moment__buy');
      const allImages = this.querySelector('.tfl-moment__all-images');
      const lightbox = this.querySelector('[data-image-lightbox]');
      const lightboxImage = this.querySelector('[data-lightbox-image]');
      const lightboxDetailControl = this.querySelector('[data-lightbox-detail-control]');
      const lightboxDetailButton = this.querySelector('[data-lightbox-detail-button]');
      const mainImageForLightbox = this.querySelector('.tfl-moment__main-image');
      let heroSwipeJustHappened = false;

      const openLightbox = (url, alt = '', embroideryDetail = false) => {
        if (!lightbox || !lightboxImage || !url) return;

        lightboxImage.src = url;
        lightboxImage.alt = alt || '';

        lightbox.classList.remove('is-detail-zoomed', 'is-detail-dragging');
        lightbox.classList.toggle('is-embroidery-detail', embroideryDetail);

        lightboxImage.style.setProperty('--tfl-pan-x', '0px');
        lightboxImage.style.setProperty('--tfl-pan-y', '0px');

        if (lightboxDetailControl) {
          lightboxDetailControl.hidden = !embroideryDetail;
        }

        if (lightboxDetailButton) {
          lightboxDetailButton.setAttribute('aria-pressed', 'false');
          lightboxDetailButton.textContent = 'CLICK TO SEE THE DETAIL';
        }

        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tfl-image-lightbox-open');

        const closeButton = lightbox.querySelector('.tfl-moment__lightbox-close');
        if (closeButton) closeButton.focus();
      };

      const closeLightbox = () => {
        if (!lightbox) return;

        lightbox.classList.remove('is-open', 'is-embroidery-detail', 'is-detail-zoomed', 'is-detail-dragging');
        lightbox.setAttribute('aria-hidden', 'true');

        lightboxImage.style.setProperty('--tfl-pan-x', '0px');
        lightboxImage.style.setProperty('--tfl-pan-y', '0px');

        if (lightboxDetailControl) {
          lightboxDetailControl.hidden = true;
        }

        if (lightboxDetailButton) {
          lightboxDetailButton.setAttribute('aria-pressed', 'false');
          lightboxDetailButton.textContent = 'CLICK TO SEE THE DETAIL';
        }

        document.body.classList.remove('tfl-image-lightbox-open');
      };

      if (mainImageForLightbox) {
        const heroZoomArea = this.querySelector('[data-hero-embroidery-zoom]');

        const openHeroEmbroidery = () => {
          const embroideryDetail = heroZoomArea
            ? heroZoomArea.dataset.activeDetail === 'true'
            : false;

          openLightbox(
            mainImageForLightbox.currentSrc || mainImageForLightbox.src,
            mainImageForLightbox.alt,
            embroideryDetail
          );
        };

        if (heroZoomArea) {
          heroZoomArea.setAttribute('tabindex', '0');
          heroZoomArea.setAttribute('role', 'button');
          heroZoomArea.setAttribute('aria-label', 'Open product image');

          heroZoomArea.addEventListener('click', (event) => {
            event.preventDefault();

            /* A horizontal mobile swipe can also produce a synthetic click.
               Ignore that one click so swiping never opens the lightbox. */
            if (heroSwipeJustHappened) {
              heroSwipeJustHappened = false;
              return;
            }

            openHeroEmbroidery();
          });

          heroZoomArea.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openHeroEmbroidery();
            }
          });
        }
      }

      if (lightboxDetailButton && lightbox) {
        lightboxDetailButton.addEventListener('click', () => {
          const zoomed = lightbox.classList.toggle('is-detail-zoomed');

          if (!zoomed) {
            lightbox.classList.remove('is-detail-dragging');
            lightboxImage.style.setProperty('--tfl-pan-x', '0px');
            lightboxImage.style.setProperty('--tfl-pan-y', '0px');
          }

          lightboxDetailButton.setAttribute('aria-pressed', String(zoomed));
          lightboxDetailButton.textContent = zoomed
            ? 'BACK TO FULL VIEW'
            : 'CLICK TO SEE THE DETAIL';
        });
      }

      /*
        Mobile / touch panning while detail zoom is active.
        Uses pointer events so it also works with a mouse if desired.
      */
      if (lightbox && lightboxImage) {
        let panPointerId = null;
        let panStartX = 0;
        let panStartY = 0;
        let panBaseX = 0;
        let panBaseY = 0;
        let panX = 0;
        let panY = 0;

        const applyPan = () => {
          lightboxImage.style.setProperty('--tfl-pan-x', `${panX}px`);
          lightboxImage.style.setProperty('--tfl-pan-y', `${panY}px`);
        };

        const clampPan = () => {
          const rect = lightboxImage.getBoundingClientRect();
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;

          /*
            Keep enough of the image inside the viewport so it cannot be
            dragged completely away. These bounds feel natural at 2x zoom.
          */
          const maxX = Math.max(0, (rect.width - viewportWidth) / 2 + viewportWidth * 0.34);
          const maxY = Math.max(0, (rect.height - viewportHeight) / 2 + viewportHeight * 0.28);

          panX = Math.max(-maxX, Math.min(maxX, panX));
          panY = Math.max(-maxY, Math.min(maxY, panY));
        };

        lightboxImage.addEventListener('dragstart', (event) => {
          event.preventDefault();
        });

        lightboxImage.addEventListener('mousedown', (event) => {
          if (lightbox.classList.contains('is-detail-zoomed')) {
            event.preventDefault();
          }
        });

        lightboxImage.addEventListener('pointerdown', (event) => {
          if (!lightbox.classList.contains('is-detail-zoomed')) return;

          panPointerId = event.pointerId;
          panStartX = event.clientX;
          panStartY = event.clientY;
          panBaseX = panX;
          panBaseY = panY;

          lightbox.classList.add('is-detail-dragging');

          try {
            lightboxImage.setPointerCapture(event.pointerId);
          } catch (e) {}

          event.preventDefault();
        });

        lightboxImage.addEventListener('pointermove', (event) => {
          if (
            panPointerId === null ||
            event.pointerId !== panPointerId ||
            !lightbox.classList.contains('is-detail-zoomed')
          ) return;

          panX = panBaseX + (event.clientX - panStartX);
          panY = panBaseY + (event.clientY - panStartY);

          clampPan();
          applyPan();

          event.preventDefault();
        });

        const endPan = (event) => {
          if (panPointerId === null) return;

          if (event && event.pointerId !== undefined && event.pointerId !== panPointerId) {
            return;
          }

          try {
            if (event && event.pointerId !== undefined) {
              lightboxImage.releasePointerCapture(event.pointerId);
            }
          } catch (e) {}

          panPointerId = null;
          lightbox.classList.remove('is-detail-dragging');
        };

        lightboxImage.addEventListener('pointerup', endPan);
        lightboxImage.addEventListener('pointercancel', endPan);
        lightboxImage.addEventListener('lostpointercapture', endPan);

        /*
          If the lightbox is resized/orientation changes, gently keep the
          current pan within sane bounds.
        */
        window.addEventListener('resize', () => {
          if (!lightbox.classList.contains('is-detail-zoomed')) return;
          clampPan();
          applyPan();
        });

        /*
          Keep JS pan state in sync when zoom gets reset elsewhere.
        */
        const panResetObserver = new MutationObserver(() => {
          if (!lightbox.classList.contains('is-detail-zoomed')) {
            panX = 0;
            panY = 0;
            panBaseX = 0;
            panBaseY = 0;
            applyPan();
          }
        });

        panResetObserver.observe(lightbox, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (lightbox) {
        lightbox.querySelectorAll('[data-lightbox-close]').forEach((closeControl) => {
          closeControl.addEventListener('click', closeLightbox);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
        });
      }

      const positionReviews = () => {
        if (!reviews || !gallery || !buy) return;

        if (window.matchMedia('(max-width: 899px)').matches) {
          if (reviews.parentElement !== buy) buy.appendChild(reviews);
        } else if (reviews.parentElement !== gallery) {
          if (allImages) {
            allImages.insertAdjacentElement('afterend', reviews);
          } else {
            gallery.appendChild(reviews);
          }
        }
      };

      positionReviews();
      window.addEventListener('resize', positionReviews);

      const select = this.querySelector('[data-variant]');
      if (!select) return;

      this.ready = true;

      const imageData = this.querySelector('[data-moment-images]');
      let productImages = [];

      if (imageData) {
        try {
          productImages = JSON.parse(imageData.textContent);
        } catch (error) {
          productImages = [];
        }
      }

      const fields = [...this.querySelectorAll('[data-option-position]')];

      const colourField = this.querySelector('[data-colour-option]');
      const mobileColour = this.querySelector('[data-mobile-colour]');
      const mobileColourValues = this.querySelector('[data-mobile-colour-values]');
      const mobileColourChoice = this.querySelector('[data-mobile-colour-choice]');

      if (colourField && mobileColour && mobileColourValues) {
        const colourButtons = [...colourField.querySelectorAll('[data-value]')];

        colourButtons.forEach((sourceButton) => {
          const proxyButton = sourceButton.cloneNode(true);
          proxyButton.removeAttribute('id');

          proxyButton.addEventListener('click', () => {
            sourceButton.click();
          });

          mobileColourValues.appendChild(proxyButton);
        });

        mobileColour.hidden = false;
      }

      const syncMobileColour = () => {
        if (!colourField || !mobileColourValues) return;

        const selected = colourField.querySelector('[data-value][aria-pressed="true"]');

        if (mobileColourChoice) {
          mobileColourChoice.textContent = selected ? selected.dataset.value : '';
        }

        [...mobileColourValues.querySelectorAll('[data-value]')].forEach((proxyButton) => {
          const sourceButton = [...colourField.querySelectorAll('[data-value]')]
            .find((button) => button.dataset.value === proxyButton.dataset.value);

          if (!sourceButton) return;

          proxyButton.setAttribute('aria-pressed', sourceButton.getAttribute('aria-pressed') || 'false');
          proxyButton.dataset.sold = sourceButton.dataset.sold || 'false';
        });
      };

      const variants = [...select.options].map((option) => ({
        id: option.value,
        values: JSON.parse(option.dataset.options),
        available: option.dataset.available === 'true',
        price: option.dataset.price,
        compare: option.dataset.compare,
        image: option.dataset.image
      }));

      const initial = variants.find((variant) => variant.id === select.value);
      if (!initial) return;

      const choices = [...initial.values];
      const button = this.querySelector('[data-add-button]');
      const status = this.querySelector('[data-status]');

      const viewerTabs = [...this.querySelectorAll('[data-viewer-tab]')];
      const viewerTabOneDefaultLabel = viewerTabs[0]?.textContent.trim() || '';
      const heroZoomAreaForViewer = this.querySelector('[data-hero-embroidery-zoom]');

      const activateViewerTab = (tab) => {
        if (!tab || !mainImageForLightbox) return;

        viewerTabs.forEach((candidate) => {
          const active = candidate === tab;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-selected', String(active));
        });

        const viewIndex = Number(tab.dataset.viewIndex);
        let url = tab.dataset.image;

        /*
          Viewer metafield images are fixed product-level overrides. Resolve
          them again at click time so colour/variant image refreshes cannot
          silently replace a custom close-up image.
        */
        if (viewIndex === 1 && this.getAttribute('data-viewer-override-2')) {
          url = this.getAttribute('data-viewer-override-2');
        } else if (viewIndex === 2 && this.getAttribute('data-viewer-override-3')) {
          url = this.getAttribute('data-viewer-override-3');
        } else if (
          viewIndex === 0 &&
          this.getAttribute('data-viewer-override-1') &&
          !tab.dataset.backPrintActive
        ) {
          url = this.getAttribute('data-viewer-override-1');
        }

        const alt = tab.dataset.alt || this.querySelector('.tfl-moment__product-title')?.textContent || '';

        if (url) {
          mainImageForLightbox.removeAttribute('srcset');
          mainImageForLightbox.removeAttribute('width');
          mainImageForLightbox.removeAttribute('height');
          mainImageForLightbox.src = url;
          mainImageForLightbox.alt = alt;
        }

        if (heroZoomAreaForViewer) {
          heroZoomAreaForViewer.dataset.activeDetail =
            tab.dataset.detailZoom === 'true' ? 'true' : 'false';
        }
      };

      viewerTabs.forEach((tab) => {
        tab.addEventListener('click', () => activateViewerTab(tab));
      });

      /* =========================================================
         MOBILE SWIPE — THREE VIEWER IMAGES
         Swipe left = next view. Swipe right = previous view.
         Desktop behaviour remains unchanged.
         ========================================================= */
      if (heroZoomAreaForViewer && viewerTabs.length > 1) {
        let swipeStartX = 0;
        let swipeStartY = 0;
        let swipeTracking = false;
        let swipeMoved = false;

        const mobileViewer = () => window.matchMedia('(max-width: 899px)').matches;

        const activeViewerIndex = () => {
          const index = viewerTabs.findIndex(
            (tab) => tab.getAttribute('aria-selected') === 'true'
          );
          return index === -1 ? 0 : index;
        };

        const moveViewerBy = (direction) => {
          const currentIndex = activeViewerIndex();
          const nextIndex = Math.max(
            0,
            Math.min(viewerTabs.length - 1, currentIndex + direction)
          );

          if (nextIndex === currentIndex) return;

          activateViewerTab(viewerTabs[nextIndex]);

          /* Keep the active tab visible on narrow screens. */
          viewerTabs[nextIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        };

        heroZoomAreaForViewer.addEventListener('touchstart', (event) => {
          if (!mobileViewer() || event.touches.length !== 1) return;

          const touch = event.touches[0];
          swipeStartX = touch.clientX;
          swipeStartY = touch.clientY;
          swipeTracking = true;
          swipeMoved = false;
        }, { passive: true });

        heroZoomAreaForViewer.addEventListener('touchmove', (event) => {
          if (!swipeTracking || !mobileViewer() || event.touches.length !== 1) return;

          const touch = event.touches[0];
          const deltaX = touch.clientX - swipeStartX;
          const deltaY = touch.clientY - swipeStartY;

          /* Only treat the gesture as a swipe when horizontal movement
             clearly beats vertical movement. This keeps page scrolling natural. */
          if (Math.abs(deltaX) > 12 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
            swipeMoved = true;
          }
        }, { passive: true });

        heroZoomAreaForViewer.addEventListener('touchend', (event) => {
          if (!swipeTracking || !mobileViewer()) return;

          swipeTracking = false;

          const touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          const deltaX = touch.clientX - swipeStartX;
          const deltaY = touch.clientY - swipeStartY;
          const horizontalSwipe =
            swipeMoved &&
            Math.abs(deltaX) >= 45 &&
            Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

          if (!horizontalSwipe) return;

          /* Prevent the click generated after touchend from opening lightbox. */
          heroSwipeJustHappened = true;

          if (deltaX < 0) {
            moveViewerBy(1);
          } else {
            moveViewerBy(-1);
          }

          /* Reset automatically in case a browser does not emit the follow-up click. */
          window.setTimeout(() => {
            heroSwipeJustHappened = false;
          }, 450);
        }, { passive: true });
      }

      const setViewerTabImage = (index, image) => {
        const tab = viewerTabs[index];
        if (!tab || !image || !image.url) return;

        tab.dataset.image = image.url;
        tab.dataset.alt = image.alt || '';

        if (tab.getAttribute('aria-selected') === 'true') {
          activateViewerTab(tab);
        }
      };

      const showImage = (url, alt) => {
        const image = this.querySelector('.tfl-moment__main-image');
        if (!image || !url) return;

        image.removeAttribute('srcset');
image.removeAttribute('width');
image.removeAttribute('height');
image.style.width = '100%';
image.style.height = 'auto';
image.style.maxHeight = 'none';
image.style.objectFit = 'contain';
image.src = url;
image.alt = alt || this.querySelector('.tfl-moment__product-title').textContent;

        this.querySelectorAll('[data-image]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item.dataset.image === url));
        });

        if (heroZoomAreaForViewer) {
          heroZoomAreaForViewer.dataset.activeDetail = 'false';
        }
      };

      const setDetailImage = (buttonElement, image) => {
        if (!buttonElement || !image) return;

        buttonElement.dataset.image = image.url;
        buttonElement.dataset.alt = image.alt || '';

        const thumbnail = buttonElement.querySelector('img');
        if (thumbnail) {
          thumbnail.removeAttribute('srcset');
          thumbnail.src = image.url;
          thumbnail.alt = image.alt || '';
        }
      };

      const imageUsesVariant = (image, variantId) => {
        if (!image || !Array.isArray(image.variant_ids)) return false;
        return image.variant_ids.map(String).includes(String(variantId));
      };

      const fileKey = (url) => {
        if (!url) return '';

        try {
          return decodeURIComponent(new URL(url, window.location.origin).pathname)
            .split('/')
            .pop()
            .replace(/_(\d+x\d+|\d+x|x\d+)(?=\.[^.]+$)/i, '')
            .toLowerCase();
        } catch (error) {
          return String(url)
            .split('?')[0]
            .split('/')
            .pop()
            .replace(/_(\d+x\d+|\d+x|x\d+)(?=\.[^.]+$)/i, '')
            .toLowerCase();
        }
      };

      const findVariantImageIndex = (variant) => {
        const assignedIndex = productImages.findIndex((image) =>
          imageUsesVariant(image, variant.id)
        );

        if (assignedIndex !== -1) return assignedIndex;

        const variantKey = fileKey(variant.image);
        if (!variantKey) return -1;

        return productImages.findIndex((image) =>
          fileKey(image.url) === variantKey
        );
      };

      const normaliseColourKey = (value) => {
        return String(value || '')
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      };

      const colourAliases = (value) => {
        const key = normaliseColourKey(value);

        const aliases = {
          'black': ['black'],
          'white': ['white'],
          'charcoal-heather': ['charcoal-heather', 'charcoal'],
          'carbon-grey': ['carbon-grey', 'carbon-gray', 'carbon'],
          'carbon-gray': ['carbon-grey', 'carbon-gray', 'carbon'],
          'navy-blazer': ['navy-blazer', 'navy'],
          'navy': ['navy-blazer', 'navy'],
          'team-red': ['team-red', 'red'],
          'red': ['team-red', 'red'],
          'team-royal': ['team-royal', 'royal-blue', 'royal'],
          'royal': ['team-royal', 'royal-blue', 'royal'],
          'royal-blue': ['team-royal', 'royal-blue', 'royal'],
          'bone': ['bone'],
          'sport-grey': ['sport-grey', 'sport-gray'],
          'sport-gray': ['sport-grey', 'sport-gray'],
          'dark-heather': ['dark-heather'],
          'graphite-heather': ['graphite-heather', 'graphite']
        };

        return aliases[key] || [key];
      };

      const imageSearchText = (image) => {
        if (!image) return '';

        let urlText = '';
        try {
          urlText = decodeURIComponent(new URL(image.url, window.location.origin).pathname);
        } catch (error) {
          urlText = String(image.url || '').split('?')[0];
        }

        return normaliseColourKey(`${urlText} ${image.alt || ''}`);
      };

      const backPrintIsSelected = () => {
        const fullMomentField = fields.find((field) =>
          field.classList.contains('tfl-moment__option--full-moment')
        );

        if (!fullMomentField) return false;

        const fullMomentIndex = fields.indexOf(fullMomentField);
        if (fullMomentIndex === -1) return false;

        const selectedValue = String(choices[fullMomentIndex] || '')
          .toLowerCase()
          .trim();

        if (!selectedValue) return false;

        if (
          selectedValue === 'no' ||
          selectedValue.startsWith('no -') ||
          selectedValue.includes('no back') ||
          selectedValue.includes('without back') ||
          selectedValue.includes('front only') ||
          selectedValue.includes('embroidery only')
        ) {
          return false;
        }

        return (
          selectedValue === 'yes' ||
          selectedValue.startsWith('yes -') ||
          selectedValue.includes('back') ||
          selectedValue.includes('printed')
        );
      };

      const showDirectColourGroup = () => {
        if (!colourField || productImages.length === 0) return false;

        const colourFieldIndex = fields.indexOf(colourField);
        if (colourFieldIndex === -1) return false;

        const colourButtons = [...colourField.querySelectorAll('[data-value]')];
        if (!colourButtons.length) return false;

        const selectedColour = choices[colourFieldIndex];
        const aliases = colourAliases(selectedColour);
        const isBackPrint = backPrintIsSelected();

        const isBackPrintImage = (image) => {
          const haystack = imageSearchText(image);
          return (
            haystack.includes('front-and-back') ||
            haystack.includes('front-back') ||
            haystack.includes('back-print') ||
            haystack.includes('back-story')
          );
        };

        const matchesColour = (image, aliasList = aliases) => {
          const haystack = imageSearchText(image);
          return aliasList.some((alias) => alias && haystack.includes(alias));
        };

        /*
          Split the optional front-and-back mock-up away from the normal
          three-image colour set. This keeps the existing 3-image viewer
          intact while allowing only tab 1 to change for Back Print.
        */
        let colourMatches = productImages.filter((image) => matchesColour(image));
        let group = colourMatches.filter((image) => !isBackPrintImage(image));
        let backImage = colourMatches.find((image) => isBackPrintImage(image)) || null;

        /*
          Extra fallback for older That Moment products whose Back Story
          option is simply Yes/No. Their back mock-ups still follow the
          colour order, so map the selected colour to the matching back
          image if filename matching does not find one cleanly.
        */
        if (isBackPrint && !backImage) {
          const backImages = productImages.filter((image) => isBackPrintImage(image));
          if (backImages.length === colourButtons.length) {
            const colourIndex = colourButtons.findIndex(
              (button) => button.dataset.value === selectedColour
            );
            if (colourIndex >= 0) backImage = backImages[colourIndex] || null;
          }
        }

        /*
          Short aliases such as "red" can occasionally catch too much.
          Prefer a more specific alias when it gives a clean 3 + 1 set.
        */
        if (group.length !== 3 || (isBackPrint && !backImage)) {
          for (const alias of aliases) {
            if (!alias) continue;

            const specificMatches = productImages.filter((image) =>
              imageSearchText(image).includes(alias)
            );
            const specificGroup = specificMatches.filter((image) => !isBackPrintImage(image));
            const specificBack = specificMatches.find((image) => isBackPrintImage(image)) || null;

            if (specificGroup.length === 3) {
              group = specificGroup;
              backImage = specificBack;
              if (!isBackPrint || backImage) break;
            }
          }
        }

        /*
          Fallback for products whose filenames do not contain a usable
          colour name: ignore all optional back-print images, then retain
          the established 3-images-per-colour positional convention.
        */
        if (group.length !== 3) {
          const standardImages = productImages.filter((image) => !isBackPrintImage(image));

          if (standardImages.length === colourButtons.length * 3) {
            const colourIndex = colourButtons.findIndex(
              (button) => button.dataset.value === selectedColour
            );

            if (colourIndex >= 0) {
              group = standardImages.slice(colourIndex * 3, colourIndex * 3 + 3);
            }
          }
        }

        if (group.length !== 3 || group.some((image) => !image || !image.url)) {
          return false;
        }

        /*
          Optional Back Print changes ONLY viewer slot 1.
          Slots 2 and 3 always remain the normal selected-colour images.
        */
        const productTitle = this.querySelector('.tfl-moment__product-title')?.textContent || '';

        const override1 = this.getAttribute('data-viewer-override-1')
          ? { url: this.getAttribute('data-viewer-override-1'), alt: `${productTitle} view 1` }
          : null;

        const override2 = this.getAttribute('data-viewer-override-2')
          ? { url: this.getAttribute('data-viewer-override-2'), alt: `${productTitle} view 2` }
          : null;

        const override3 = this.getAttribute('data-viewer-override-3')
          ? { url: this.getAttribute('data-viewer-override-3'), alt: `${productTitle} view 3` }
          : null;

        const productDetailOverride = this.dataset.productDetailOverride
          ? {
              url: this.dataset.productDetailOverride,
              alt: `${productTitle} stitching close-up`
            }
          : null;

        if (viewerTabs[0]) {
          viewerTabs[0].dataset.backPrintActive = String(Boolean(isBackPrint && backImage));
        }

        setViewerTabImage(0, isBackPrint && backImage ? backImage : (override1 || group[0]));
        setViewerTabImage(1, override2 || productDetailOverride || group[1]);
        setViewerTabImage(2, override3 || group[2]);

        const activeTab =
          viewerTabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
          viewerTabs[0];

        if (activeTab) activateViewerTab(activeTab);

        return true;
      };

      const showImageGroup = (variant) => {
        if (!variant || productImages.length === 0) return false;

        const imageIndex = findVariantImageIndex(variant);
        if (imageIndex === -1) return false;

        /*
          TFL media convention:
          each colour is stored as a consecutive three-image set:
          main, embroidery/detail, finish.
          Shopify's assigned variant image anchors the correct set.
        */
        const groupStart = Math.floor(imageIndex / 3) * 3;
        const group = productImages.slice(groupStart, groupStart + 3);

        if (group.length < 3) return false;

        const productTitle = this.querySelector('.tfl-moment__product-title')?.textContent || '';

        const override1 = this.getAttribute('data-viewer-override-1')
          ? { url: this.getAttribute('data-viewer-override-1'), alt: `${productTitle} view 1` }
          : null;

        const override2 = this.getAttribute('data-viewer-override-2')
          ? { url: this.getAttribute('data-viewer-override-2'), alt: `${productTitle} view 2` }
          : null;

        const override3 = this.getAttribute('data-viewer-override-3')
          ? { url: this.getAttribute('data-viewer-override-3'), alt: `${productTitle} view 3` }
          : null;

        const productDetailOverride = this.dataset.productDetailOverride
          ? {
              url: this.dataset.productDetailOverride,
              alt: `${productTitle} stitching close-up`
            }
          : null;

        setViewerTabImage(0, override1 || group[0]);
        setViewerTabImage(1, override2 || productDetailOverride || group[1]);
        setViewerTabImage(2, override3 || group[2]);

        const activeTab = viewerTabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || viewerTabs[0];
        if (activeTab) activateViewerTab(activeTab);

        return true;
      };

      const update = (changeImage = true) => {
        const variant = variants.find((candidate) =>
          candidate.values.every((value, index) => value === choices[index])
        );

        fields.forEach((field, index) => {
          const choiceLabel = field.querySelector('[data-choice]');
          if (choiceLabel) choiceLabel.textContent = choices[index];

          field.querySelectorAll('[data-value]').forEach((choiceButton) => {
            choiceButton.setAttribute(
              'aria-pressed',
              String(choiceButton.dataset.value === choices[index])
            );

            const possible = variants.some((candidate) =>
              candidate.available &&
              candidate.values.every((value, valueIndex) =>
                value === (
                  valueIndex === index
                    ? choiceButton.dataset.value
                    : choices[valueIndex]
                )
              )
            );

            choiceButton.dataset.sold = String(!possible);
          });
        });

        syncMobileColour();

        select.value = variant ? variant.id : '';

        const nativeVariantInput = this.querySelector('[data-tfl-variant-id]');
        if (nativeVariantInput) {
          nativeVariantInput.value = variant ? variant.id : '';
          nativeVariantInput.disabled = !variant || !variant.available;
        }

        button.disabled = !variant || !variant.available;

        if (!variant) {
          button.textContent = this.dataset.unavailable;
        } else if (!variant.available) {
          button.textContent = this.dataset.sold;
        } else {
          let selectedColour = '';
          let selectedSize = '';

          fields.forEach((field, index) => {
            const optionLabel = (field.querySelector('legend')?.textContent || '').trim().toLowerCase();
            const selectedValue = choices[index] || '';

            if (field.hasAttribute('data-colour-option') || optionLabel.includes('colour') || optionLabel.includes('color')) {
              selectedColour = selectedValue;
            } else if (optionLabel.includes('size')) {
              selectedSize = selectedValue;
            }
          });

          const buttonParts = [];
          if (selectedColour) buttonParts.push('COLOUR: ' + selectedColour.toUpperCase());
          if (selectedSize) buttonParts.push('SIZE: ' + selectedSize.toUpperCase());
          buttonParts.push(this.dataset.add);

          button.textContent = buttonParts.join(' · ');
        }

        status.textContent = button.disabled ? button.textContent : '';

        this.querySelector('[data-price]').textContent = variant
          ? variant.price
          : this.dataset.unavailable;

        const compare = this.querySelector('[data-compare]');
        compare.textContent = variant ? variant.compare : '';
        compare.hidden = !variant || !variant.compare;

        if (variant && changeImage) {
          const usedDirectColourGroup = showDirectColourGroup();

          if (!usedDirectColourGroup && !showImageGroup(variant) && variant.image) {
            showImage(variant.image);
          }
        }

        if (viewerTabs[0]) {
          viewerTabs[0].textContent = backPrintIsSelected()
            ? 'FRONT / BACK VIEW'
            : viewerTabOneDefaultLabel;
        }
      };

      fields.forEach((field, index) => {
        field.querySelectorAll('[data-value]').forEach((choiceButton) => {
          choiceButton.addEventListener('click', () => {
            const isFullMomentChoice = field.classList.contains('tfl-moment__option--full-moment');

            choices[index] = choiceButton.dataset.value;
            update(true);

            if (isFullMomentChoice && backPrintIsSelected() && viewerTabs[0]) {
              requestAnimationFrame(() => {
                activateViewerTab(viewerTabs[0]);
              });
            }

            if (field === colourField) {
              requestAnimationFrame(() => {
                showDirectColourGroup();
              });

              window.setTimeout(() => {
                showDirectColourGroup();
              }, 60);
            }
          });
        });
      });

      this.querySelectorAll('.tfl-moment__thumbs [data-image]').forEach((imageButton) => {
        imageButton.addEventListener('click', () => {
          showImage(imageButton.dataset.image, imageButton.dataset.alt);
        });
      });

      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-enhanced]').hidden = false;

      update(true);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
